import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormContainer, FormRow, FormRowView } from "components/shared";
import { UICheckbox } from "components/ui";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";
import "./mobile.css";


/**
 * @function ImportFileMapColumnsWidget
 * @return {React.Component}
 * @exported true
 * @description The Import File Map Columns widget for the ImportFileNewTemplatePage.
 */
export default function ImportFileMapColumnsWidget(props) {
    const { ui, data, onColumnChange, onChooseFile } = useStateManager();
    const columns = data.mapColumns;
    const selectedColumns = data.selectedColumns;

    const getColumnItems = (columns, columnNum) => {
        return columns.reduce((acc, item) => {
            return [...acc, <CustomSelectItem dataPoint={ `Map_Column_${ columnNum}_Select_Option_${ item.id }`} className={item.isSelected ? `${item.class} column-selected`: item.class} key={item.id} value={item}>{item.value}</CustomSelectItem>]
        }, []);
    };

    const activeSelects = Object.keys(ui).reduce((acc, key) => {
        if(key.includes("mapColumnSelect")) {
            const selectIsActive = ui[key].isActive;
            if(selectIsActive) acc.push(key[key.length - 1]);
        }
        return acc;
    }, []);

    const formRows = selectedColumns.map((item, i) => {
        const columnNum = i + 1;

        return (
            <FormRowView key={item.id} text={`Column ${ columnNum }`} >
                <CustomSelect active={ activeSelects.includes(`${ i + 1 }`) ? true : false } value={item.value} onChange={onColumnChange(i.toString())}>
                    { getColumnItems(columns, columnNum) }
                </CustomSelect>
            </FormRowView>
        )
    })

    return (
        <div className="import-file-map-columns-widget">
            <div className="flex-container flex-horizontal align-center widget-title">
                <h2 className="label-with-icon">Map Columns</h2>
                <SVGAsset id="InfoIcon" />
            </div>
            <FormContainer>
                <FormRow>
                    <DisabledPrompt>
                        <UICheckbox label="Use Custom Transaction Code" value="" />
                    </DisabledPrompt>
                </FormRow>
                <FormRow className="flex-horizontal align-center column-custom-select-container">
                    {formRows}
                </FormRow>
            </FormContainer>
        </div>
    )
}
